import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { HashRouter } from 'react-router-dom';

// HashRouter instead of BrowserRouter: the production Apache vhost has
// AllowOverride disabled, so it can't be configured to fall back to
// index.html for client-side routes. With HashRouter, every route lives
// after the `#` (e.g. /#/irim3d/2019), which never reaches the server --
// a hard refresh or a direct/bookmarked link just reloads `/` (a real
// file) and React Router reads the hash client-side. No server change
// needed, and it keeps working regardless of who controls Apache.
ReactDOM.render(
  <React.StrictMode>
    <HashRouter basename={process.env.PUBLIC_URL}>
		<App />
	</HashRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
